import { render, staticRenderFns } from "./SelfAssesment.vue?vue&type=template&id=62a212ec&scoped=true"
import script from "./SelfAssesment.vue?vue&type=script&lang=js"
export * from "./SelfAssesment.vue?vue&type=script&lang=js"
import style0 from "./SelfAssesment.vue?vue&type=style&index=0&id=62a212ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a212ec",
  null
  
)

export default component.exports